module.exports = __webpack_public_path__ + "static/img/logo.a5d6fa57.png";